import { render, staticRenderFns } from "./roleBody.vue?vue&type=template&id=ce655962&scoped=true&"
import script from "./roleBody.vue?vue&type=script&lang=js&"
export * from "./roleBody.vue?vue&type=script&lang=js&"
import style0 from "./roleBody.vue?vue&type=style&index=0&id=ce655962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce655962",
  null
  
)

export default component.exports